import { store } from 'src/store/index.js';
import { h, resolveComponent } from 'vue';

const mainChildren = [
  {
    path: '',
    name: 'default',
    component: () => import('pages/Home.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'home',
    name: 'home',
    component: () => import('pages/Home.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: 'leden-aanbiedingen',
    name: 'member-offers',
    component: () => import('pages/MemberOffers.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayReadMemberOffer;
      },
    },
  },
  {
    path: 'uitloggen',
    name: 'logout',
    component: () => import('pages/auth/Logout'),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: 'polisoverzicht',
    name: 'policy-overview',
    component: () => import('src/pages/MyHealthInsurance.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayReadInsurance;
      },
    },
  },

  {
    path: 'rekeningen-en-betalingen',
    name: 'bills-payments',
    component: () => import('pages/BillsAndPayments.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayReadInvoice;
      },
    },
  },
  {
    path: 'betalingsregeling',
    name: 'payment-arrangement',
    component: () => import('pages/PaymentArrangement.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayCreatePaymentArrangement;
      },
    },
  },
  {
    path: 'polis-wijzigen',
    name: 'edit-policy',
    component: () => import('pages/EditPolicy.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayUpdateInsurance;
      },
    },
  },

  {
    path: `polis-aanvragen/:selectedYear/:contractCode/:agreementId/:shouldResetSelection`,
    name: 'request-policy-selected-year',

    props(route) {
      const props = {
        ...route.params,
      };
      props.selectedYear = +props.selectedYear;
      props.shouldResetSelection = props.shouldResetSelection === 'true' || props.shouldResetSelection === true;

      return props;
    },
    component: () => import('src/pages/RequestPolicy.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayUpdateInsurance;
      },
    },
  },

  {
    path: `polis-wijzigen/:selectedYear/:contractCode/:agreementId/:shouldResetSelection`,
    name: 'edit-policy-selected-year',

    props(route) {
      const props = {
        ...route.params,
      };
      props.selectedYear = +props.selectedYear;
      props.shouldResetSelection = props.shouldResetSelection === 'true' || props.shouldResetSelection === true;

      return props;
    },
    component: () => import('src/pages/EditPolicy.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayUpdateInsurance;
      },
    },
  },

  {
    path: 'berichtenbox',
    name: 'message-box',
    props: true,
    component: () => import('pages/MessageBox.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayReadMessages;
      },
    },
  },
  {
    path: `berichtenbox/:cluster`,
    name: 'message-box-cluster',
    props: true,
    component: () => import('pages/MessageBox.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayReadMessages;
      },
    },
  },
  {
    path: 'verzekerde-bijschrijven',
    name: 'add-insuree-to-policy',
    component: () => import('pages/AddInsuree.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return (
          store.getters['user/isLoggedIn'] &&
          store.getters['user/permissions'].mayCreateInsuredPerson &&
          store.getters['agreement/hasBasicInsurance']
        );
      },
    },
  },
  {
    path: 'zorgpas-ehic',
    name: 'insurance-card',
    component: () => import('src/pages/InsuranceCards.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayCreateEHIC;
      },
    },
  },
  {
    path: 'vergoedingsdocumenten',
    name: 'reimbursement-documents',

    component: () => import('pages/ReimbursementDocuments.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayCompensationDocument;
      },
    },
  },
  {
    path: 'persoonlijke-gegevens-wijzigen',
    name: 'edit-personal-info',
    component: () => import('pages/EditPersonalInfo.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayUpdatePersonalDetails;
      },
    },
  },
  {
    path: 'persoonlijke-gegevens',
    name: 'personal-info',
    component: () => import('pages/PersonalInfo.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayReadPersonalDetails;
      },
    },
  },
  {
    path: 'betaal-en-rekeninggegevens',
    name: 'payment-details',
    component: () => import('pages/PaymentDetails.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayReadPaymentDetails;
      },
    },
  },
  {
    path: `betaalgegevens-wijzigen/:agreementId`,
    name: 'edit-payment-details',
    component: () => import('pages/EditPaymentDetails.vue'),
    props(route) {
      const props = {
        ...route.params,
      };
      props.selectedYear = +props.selectedYear;

      return props;
    },
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayUpdatePaymentDetails;
      },
    },
  },
  {
    path: 'contactformulier',
    name: 'contact-form',
    component: () => import('pages/ContactForm.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayCreateContact;
      },
    },
  },
  {
    path: 'mijn-zorgkosten',
    name: 'healthcare-costs',
    component: () => import('pages/HealthcareCosts.vue'),
    props(route) {
      const props = {
        ...route.query,
      };
      return props;
    },
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayReadDeclaration;
      },
    },
  },
  {
    path: 'aanvraag-zittend-ziekenvervoer',
    name: 'request-seated-patient-transport',
    component: () => import('pages/RequestSeatedPatientTransport.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayCreateDeclaration;
      },
    },
  },
  {
    path: 'indienen-zorgkosten',
    name: 'submit-healthcare-costs',
    component: () => import('pages/SubmitHealthcareCosts.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayCreateDeclaration;
      },
    },
  },
  {
    path: 'contact-opnemen',
    name: 'contact',
    component: () => import('pages/Contact.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayReadContact;
      },
    },
  },
  {
    path: 'instellingen',
    name: 'settings',
    component: () => import('pages/Settings.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayReadAccount;
      },
    },
  },
  {
    path: 'wijzig-instellingen',
    name: 'edit-settings',
    component: () => import('pages/EditSettings.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayUpdateAccount;
      },
    },
  },
  {
    path: 'contactgegevens-wijzigen',
    name: 'edit-contact-details',
    component: () => import('pages/EditContactDetails.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayUpdateAccount;
      },
    },
  },
  {
    path: `medische-selectie/:selectedYear/:contractCode/:agreementId`,
    name: 'medical-selection',
    props(route) {
      const props = {
        ...route.params,
      };
      props.selectedYear = +props.selectedYear;

      return props;
    },
    component: () => import('pages/EditPolicyMedicalSelection.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayUpdateInsurance;
      },
    },
  },
  {
    path: 'verzekeringsrecht',
    name: 'insurance-right',
    component: () => import('pages/InsuranceRightCheck.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        const isCheckRequired = store.getters['insuranceRight/insuranceRight']?.isCheckRequired;
        return (
          store.getters['user/isLoggedIn'] &&
          store.getters['user/permissions'].mayCreateInsuranceRight &&
          isCheckRequired
        );
      },
    },
  },
  {
    path: 'zorgbemiddeling-aanvragen',
    name: 'request-care-mediation',
    component: () => import('pages/RequestCareMediation.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayCreateCareMediation;
      },
    },
  },
  {
    path: 'behandeling-buitenland-aanvragen',
    name: 'request-treatment-abroad',
    component: () => import('pages/RequestTreatmentAbroad.vue'),
    meta: {
      requiresAuth: true,
      isAuthorized: () => {
        return store.getters['user/isLoggedIn'] && store.getters['user/permissions'].mayCreateTreatmentAbroad;
      },
    },
  },
];
const authChildren = [
  {
    path: `inloggen`,
    name: 'login',
    component: () => import('pages/auth/Login'),
    props: (route) => ({
      labelCode: route.params.label,
    }),
  },
  {
    path: `inloggen`,
    name: 'login-after-logout',
    meta: {
      canBeIntercepted: false,
    },
    component: () => import('pages/auth/Login'),
  },
  {
    path: 'verificatie',
    name: 'verify',
    component: () => import('pages/auth/Verify'),
    props: (route) => ({
      labelCode: route.params.label,
    }),
  },
  {
    path: 'registreren',
    name: 'register',
    component: () => import('pages/auth/Register'),
    props: (route) => ({
      labelCode: route.params.label,
    }),
  },
  {
    path: 'activeren',
    name: 'activate',
    component: () => import('pages/auth/Activate'),
    props: (route) => ({
      labelCode: route.params.label,
    }),
  },
  {
    path: 'idin-activeren',
    name: 'idin-register',
    component: () => import('pages/auth/IdinRegister'),
    props: (route) => ({
      labelCode: route.params.label,
    }),
    meta: {
      isRegister: true,
    },
  },
  {
    path: 'callback/iDin-authenticatie',
    name: 'idin-authentication',
    component: () => import('pages/auth/IdinAuthentication'),
    props: (route) => ({
      sessionId: route.query.sessionId,
    }),
  },
  {
    path: 'callback/iDin-register',
    name: 'idin-register2',
    component: () => import('pages/auth/IdinIdentification'),
    props: (route) => ({
      sessionId: route.query.sessionId,
    }),
  },
  {
    path: 'callback/iDin-abort',
    name: 'idin-abort',
    component: () => import('pages/auth/IdinAbort'),
    props: (route) => ({
      sessionId: route.query.sessionId,
    }),
  },
  {
    path: 'callback/iDin-error',
    name: 'idin-error',
    component: () => import('pages/auth/IdinError'),
    props: (route) => ({
      sessionId: route.query.sessionId,
    }),
  },

  {
    path: 'callback/iDin',
    name: 'callback-idin',
    props: (route) => ({
      code: route.query.code,
      state: route.query.state,
      sessionState: route.query.session_state,
      error: route.query.error,
      errorDescription: route.query.error_description,
      labelCode: route.params.label,
    }),
    component: () => import('pages/auth/IdinCallBack'),
  },
  {
    path: 'wachtwoord',
    name: 'password',
    component: {
      render() {
        return h(resolveComponent('router-view'));
      },
    },
    props: (route) => ({
      labelCode: route.params.label,
    }),
    children: [
      {
        path: 'vergeten',
        name: 'forgot',
        component: () => import('pages/auth/password/Forgot'),
      },
      {
        path: 'resetten',
        name: 'reset',
        component: () => import('pages/auth/password/Reset'),
      },
    ],
  },
];

const splashChildren = [
  {
    path: 'splash',
    name: 'splash',
    component: () => import('pages/Splash'),
    props: (route) => ({
      labelCode: route.params.label,
    }),
  },
];

const routes = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: mainChildren,
  },
  {
    path: '/',
    component: () => import('layouts/AuthLayout.vue'),
    children: authChildren,
  },
  {
    path: '/',
    component: () => import('layouts/SplashLayout.vue'),
    children: splashChildren,
  },
];

//Always leave this as last one
if (process.env.MODE !== 'ssr') {
  routes.push({
    path: '/:pathMatch(.*)*',
    component: () => {
      if (!store.getters['user/isLoggedIn']) store.dispatch('auth/fetchUser');

      if (store.getters['user/isLoggedIn']) {
        return import('layouts/SplashLayout.vue');
      } else if (window.location.pathname === '/splash') {
        return import('layouts/MainLayout.vue');
      }

      return import('layouts/AuthLayout.vue');
    },

    children: [
      {
        path: '/:pathMatch(.*)*',
        component: () => import('pages/Error404.vue'),
      },
    ],
  });
}

export default routes;
